import React from "react";

const AvailabilityHeader = () => {
  return (
    <div className="hidden md:flex border-b-2 border-primaryBlue items-center bg-slate-100">
      <div className="p-2 w-[75px] font-semibold border-r border-gray-100 text-sm text-center">Qty</div>
      <div className="p-2 w-[200px] font-semibold border-r border-gray-100 text-sm text-center">Service</div>
      <div className="p-2 w-[200px] font-semibold border-r border-gray-100 text-sm text-center">Room/Care</div>
      <div className="p-2 w-[150px] font-semibold border-r border-gray-100 text-sm text-center">Gender</div>
      <div className="p-2 grow font-semibold border-r border-gray-100 text-sm text-center">Reimbursement</div>
      <div className="p-2 w-[150px] font-semibold border-r border-gray-100 text-sm text-center">Date Available</div>
      <div className="p-2 w-[50px]"></div>
    </div>
  );
};

export default AvailabilityHeader;
